import React, { useEffect, useState } from 'react';
import './css/packages.css';
import Button from '../../components/Button';
import { Link, Redirect } from 'react-router-dom';
import AOS from 'aos';

export default function Packages() {
  const [state, setState] = useState({ price: '', packageName: '' });
  const [redirect, setRedirect] = useState(false);
  useEffect(() => {
    // or simply just AOS.init();
    AOS.init({
      // initialise with other settings
      duration: 1000,
    });
  }, []);
  const handleSelected = (value, packageName) => {
    setState({ price: value, packageName });
    setRedirect(true);
  };
  return (
    <>
      {redirect && (
        <Redirect to={{ pathname: '/register', state: { ...state } }} />
      )}
      <div className="packages">
        <div>
          <div className="exploreF">
            READY TO START YOUR JOURNEY TO <br />
            FINANCIAL FREEDOM?
          </div>
          <div className="explore">EXPLORE OUR PACKAGES</div>
          <div className="pack">
            <div
              className="packcol"
              data-aos="fade-up"
              data-aos-delay="80"
              data-aos-duration="1400"
            >
              <div className="package">
                <div className="packagehead">ONE ON ONE TRAINING</div>
                <div className="packagecontent">
                  <p>
                    By paying for this package, you are unlocking the following
                  </p>
                  <ul>
                    <li>
                      <i className="fas fa-check"></i> <span>One-off fee</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>
                        Online Instructor in-person experience i.e one-on-one
                        online training.
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Lifetime Mentorship</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>24/7 access to training contents</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Access all recorded content</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>
                        1 on 1 access to instructor during live sessions
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Top down weekly analysis</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Support channel for live chat</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Access to student’s chatroom</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>6 months of free signal subscription</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Branded Souvenier</span>
                    </li>
                  </ul>
                  <div className="price">Price: $1,500</div>
                  <div className="button">
                    <Button
                      className="started-button2"
                      onClick={() =>
                        handleSelected(1500, 'ONE ON ONE TRAINING')
                      }
                    >
                      Pay now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="packcol second"
              data-aos="fade-up"
              data-aos-delay="90"
              data-aos-duration="1500"
            >
              <div className="package">
                <div className="packagehead">FULL ONLINE COURSE</div>
                <div className="packagecontent">
                  <p>
                    By paying for this package, you are unlocking the following
                  </p>
                  <ul>
                    <li>
                      <i className="fas fa-check"></i> <span>One-off fee</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Lifetime Mentorship</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>24/7 access to training contents</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Access all recorded content</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>
                        1 on 1 access to instructor during live sessions
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Top down weekly analysis</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Support channel for live chat</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Access to student’s chatroom</span>
                    </li>
                    <li>
                      <i className="fas fa-times"></i>{' '}
                      <span className="line-through">
                        Online Instructor in-person experience i.e one-on-one
                        online training.
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-times"></i>{' '}
                      <span className="line-through">
                        6 months of free signal subscription
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-times"></i>{' '}
                      <span className="line-through">Branded Souvenier</span>
                    </li>
                  </ul>
                  <div className="price">Price: $650</div>
                  <div className="button">
                    <Button
                      onClick={() => handleSelected(650, 'FULL ONLINE COURSE')}
                      className="started-button2"
                    >
                      Pay now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="packcol"
              data-aos="fade-up"
              data-aos-delay="100"
              data-aos-duration="1600"
            >
              <div className="package">
                <div className="packagehead">MENTORSHIP PROGRAM</div>
                <div className="packagecontent">
                  <p>
                    By paying for this package, you are unlocking the following
                  </p>
                  <ul>
                    <li>
                      <i className="fas fa-check"></i> <span>One-off fee</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Lifetime Mentorship</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Access all recorded content</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>
                        1 on 1 access to instructor during live sessions
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Top down weekly analysis</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Support channel for live chat</span>
                    </li>
                    <li>
                      <i className="fas fa-check"></i>{' '}
                      <span>Access to student’s chatroom</span>
                    </li>
                    <li>
                      <i className="fas fa-times"></i>{' '}
                      <span className="line-through">
                        24/7 access to training contents
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-times"></i>{' '}
                      <span className="line-through">
                        Online Instructor in-person experience i.e one-on-one
                        online training.
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-times"></i>{' '}
                      <span className="line-through">
                        6 months of free signal subscription
                      </span>
                    </li>
                    <li>
                      <i className="fas fa-times"></i>{' '}
                      <span className="line-through">Branded Souvenier</span>
                    </li>
                  </ul>
                  <div className="price">Price: $300</div>
                  <div className="button">
                    <Button
                      className="started-button2"
                      onClick={() => handleSelected(300, 'MENTORSHIP PROGRAM')}
                    >
                      Pay now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="inPerson">
            <h1>PHYSICAL IN-PERSON TRAINING</h1>
            <p>
              <a href="/">See Document</a>
            </p>
            <div className="button">
              <Link to="/inpersonreg">
                <Button className="payIn">Pay Now</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
